<template>
    <div>
        <span
            v-if="post.operation != 'success_create_automatic_network'"
            v-html="
                $t(`feed.operations.${operation}`, {
                    valuer: `<a href='profile/${post.valuer.id}'>${post.valuer.name}</a>`,
                    evaluated: `<a href='profile/${post.evaluated.id}'>${post.evaluated.name}</a>`,
                    type: $t(`values.network.types.${post.artifact.type}`),
                })
            "
        >
        </span>
        <span v-else v-html="$t('feed.fields.successCreateUsersNetworkMessage')"></span>
    </div>
</template>

<script>
export default {
    name: 'PostContentNetwork',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    computed: {
        operation() {
            if (this.post.operation === 'create_automatic_network' || this.post.operation === 'create_manual_network') {
                return 'has_been_added_to_network'
            } else if (this.post.operation === 'delete_network') {
                return 'has_been_deleted_from_network'
            }
        },
    },
}
</script>

<style></style>
